import React from 'react';
import { SectionHeading } from './SectionHeading';
import { howItWorksSteps as steps } from '../data/howItWorks';
export function HowItWorks() {
  return <section className="bg-paper py-20 lg:py-28" data-id="element-191" data-mp="7qshfe4iv7gy">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-192" data-mp="3pz9uqnpu2mwq">
        <div className="grid gap-14 lg:grid-cols-[0.95fr_1.05fr] lg:gap-20" data-id="element-193" data-mp="3q0uoib4bq1tj">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-194" data-mp="3u0d7308oa0t7">
            <SectionHeading eyebrow="How it works" title="Pure science. No chemicals. Just safe water." lede="Hydrosprings installs Fusion 44X, which runs a process called Hydro-pH-Infusion. Here is the entire mechanism, start to finish." data-id="element-195" data-mp="lk0azbc5yd1a" />
            <figure className="mt-10" data-id="element-196" data-mp="gsrxa33sw5ib">
              <div className="overflow-hidden rounded-2xl bg-canvas" data-id="element-197" data-mp="grqoy6e65x4a">
                <img src="https://cdn.magicpatterns.com/uploads/5qM4SMtx8m542cbe47YcbT/IMG_1896.jpg" alt="The Fusion 44X kit laid out: probe, tubing, power supply, cabling, fittings and carry bag" className="aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-198" data-mp="14i30dr8mibzm" />
              </div>
              <figcaption className="mt-3 text-[13px] text-ink-600" data-id="element-199" data-mp="31b7jgqbfsuwf">
                Every Hydrosprings install ships as a complete Fusion 44X kit
                &mdash; probe, chamber fittings, tubing and DC power supply.
              </figcaption>
            </figure>
          </div>

          <ol className="relative border-l border-ink-950/10 pl-8 lg:pl-10" data-id="element-200" data-mp="36akgu4zxpkd9">
            {steps.map((step, index) => <li key={step.title} className="relative pb-12 last:pb-0" data-id="element-201" data-mp="3kav6x5tf6uxd" data-mpi={index}>
                <span className="absolute -left-[41px] flex h-6 w-6 items-center justify-center rounded-full bg-aqua-600 text-[11px] font-semibold text-white lg:-left-[51px]" data-id="element-202" data-mp="3fb8uuzpbvkq5">
                  {index + 1}
                </span>
                <h3 className="font-display text-xl font-medium leading-snug text-ink-950 lg:text-2xl" data-id="element-203" data-mp="1ky0uksil2gx4">
                  {step.title}
                </h3>
                <p className="mt-3 max-w-md text-[15px] leading-relaxed text-ink-700" data-id="element-204" data-mp="3l1js4beqw98g">
                  {step.body}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}